export default {
  nav: {
    home: "Home",
    products: "Products",
    contact: "Contact",
    about: "About",
    download: "APP Download",
    app_download: "App Download",
    leecho: "Le-Echo",
    levue: "Le-Vue",
    lebond: "LeBond",
    lesound: "Le-Sound",
    menu: "Menu"
},
swiper: {
    _1: ["Smart Watch Series", "Learn More"],
    _2: ["Gearbox Watch Series", "Learn More"],
    _3: ["Drum roller watch Series", "Learn More"]
},
about: {
    text_0: "About Us",
    text_1: "CAS Huazhi (Shenzhen)  Ltd. is a watch industry technology platform service company.  The company's predecessor is a Hong Kong aupo professional watch company with more than 30 years of experience.  In 2008, it transformed to provide technical services for the watch industry.  The company has ① a professional team from Hong Kong traditional watch industry. ②Shenzhen hardware, software, app professional team ③Zhongshan factory base production team ④Provides (gearbox + module) custom pointer function movement, technical support for traditional watch brands and industry brands, smart watches.",
    text_2: "The technical service items are as follows:",
    text_3: "1. Smart watch Bluetooth solution service provider",
    text_4: "① Bluetooth solution (have source code, support function customization service)",
    text_5: "② 4G smart meter solution",
    text_6: "③ Hardware, software, app technical services",
    text_7: "④ Content, interface, UI, customization",
    text_8: "⑤ Smart watch after-sales technical service, app upgrade",
    text_9: "2. (Gearbox + Module) Custom pointer function movement",
    text_10: "① Customize the pointer function movement, break the traditional watch, first have the core, and then design the watch model. Conversely, the watch brand first defines the watch product function and design the dial layout. Our company provides the movement structure + hardware stacking + software Program Technical Service",
    text_11: "②Watch brands can arbitrarily arrange the position of the movement axis, choose the height of the movement axis, choose concentric multi-axis or single-axis gearbox, forward rotation, reverse rotation, speed, independent motor drive",
    text_12: "③ Select the purpose of the movement shaft, chronograph hand, metering hand, dynamic action, ratio. For example, it resembles wheel rotation, animal movements, birds, butterfly movements, cartoon character movements, etc.",
    text_13: "④ Gearbox can be selected, Ronda of Switzerland, Citizen of Japan, Seiko, Mainland China, rich and frugal",
    text_14: "⑤ Technology development, smart watches, functionalization, need cross-border technology, division of labor and cooperation, traditional movement factories only provide professional gearboxes, and leave the product definition of watch products to watch brands. Our company provides movement structure + hardware and software Professional technology platform services",
    text_15: "⑥ (Gearbox + Module) Custom pointer function movement, divided into 2 categories, A, pointer smart watch (with app), B, pointer function table (without app)"
},
contact: {
    title: "Contact Us",
    items: [{
        name: {
            name: "Contact",
            value: "Jason"
        },
        changer: {
            name: "Responsible",
            value: "Smart watch"
        },
        tel: {
            name: "Tel",
            value: "13794477351"
        },
        email: {
            name: "E-mail",
            value: "445995614@qq.com"
        }
    },{
        name: {
            name: "Contact",
            value: "Cliff"
        },
        changer: {
            name: "Responsible",
            value: "Gearbox watch"
        },
        tel: {
            name: "Tel",
            value: "15626563096"
        },
        email: {
            name: "E-mail",
            value: "cliffwong65@yahoo.com"
        }
    }],
    address:[
        {
          addrName:'Shenzhen R&D',
          companyName:"CAS HuaZhi(ShenZhen) Ltd",
          addr:  "7th Floor, Building 3, Tantou Yuheng Industrial Park, Songgang Street, Bao'an District, Shenzhen"
        },
        {
          addrName:'HK Company',
          companyName: "ETERNAL KEEN INVESTMENT LTD",
          addr: "ROOM 1003, 10/F, WANG YIP INDUSTRIAL BLDG., NO 1 ELM STREET, TAI KOK TSUI, KOWLOON HONG KONG"
      },
      {
          addrName:'Zhongshan Factory',
          companyName:"Zhongshan HCI Intelligent Technology Co., Ltd",
          addr : "No. 3 Changling Road, Nanlang Lanbian Village, Zhongshan City"
      }
    ]
},
products: {
    title: "Products",
    titleList: [{
        t_1: "Products and Technology",
        t_2s: ["Smart Watch Series", "Gearbox Watch Series", "Drum roller watch Series"]
    }],
    productList: ["Smart Watch Series", "Gearbox Watch Series", "Drum roller watch Series"]
},
download: "Scan the QR code and download",
  download_page: {
    title: "APP Download",
    download_btn: "Download",
    qr_desc: "Scan the QR code above to quickly download our application. Supports both iOS and Android platforms.",
    quick_links: "Quick Links",
    contact: "Contact Us"
  },
  footer_desc: "CAS HuaZhi (Shenzhen) Ltd., focusing on smart watch technology platform services.",
  footer_support: "Service Support",
leecho: {
  title: "Le-Echo Smart Glasses App",
  subtitle: "An innovative application designed for smart glasses, integrating intelligent interaction and personalized services",
  description: "Le-Echo is an innovative application designed specifically for smart glasses, integrating intelligent interaction and personalized services to bring users a seamless digital and reality experience. Through efficient voice control, real-time visual analysis, and context-aware technology, Le-Echo redefines the way you perceive the world—whether for communication, entertainment, or work, everything is right before your eyes.",
  feature1: {
    title: "Efficient Voice Control",
    description: "Achieve precise control of smart glasses through advanced voice recognition technology, freeing your hands"
  },
  feature2: {
    title: "Real-time Visual Analysis",
    description: "Utilize AI visual technology to analyze the surrounding environment in real-time, providing intelligent information prompts and suggestions"
  },
  feature3: {
    title: "Context-aware Technology",
    description: "Intelligently perceive current scenes and environments, automatically adjusting application functions to provide the most suitable service experience"
  },
  download: {
    title: "Download Now",
    ios_label: "iOS Download",
    ios_text: "App Store",
    android_label: "Android Download",
    android_text: "Android"
  },
  footer: "Whether for communication, entertainment, or work, Le-Echo brings everything right before your eyes",
  agreement: {
    prefix: "By downloading, you agree to the",
    user: "User Agreement",
    and: " and ",
    privacy: "Privacy Policy"
  }
},
footerNav: ["Contact Us", "About Us", "FAQ", "Terms and Conditions"],
footerFollow: "Follow Us"
};
